import draftGrades from '../data/draftGrades.json';

// Rotating editorial copy: same slot, different line depending on the day,
// so returning visitors stop reading identical headlines. Deterministic per
// day (no hydration flicker) and safe for tests via index 0 fallback.
const DRAFT_PICK_COUNT = draftGrades.draftedPickCount;
const DRAFT_TEAM_COUNT = draftGrades.teams.length;
const DRAFT_ROUND_COUNT = new Set(draftGrades.picks.map((pick) => pick.round)).size;
const DRAFT_INPUT_COUNT = Object.keys(draftGrades.methodology.weights).length;
const DRAFT_TEAM_COUNT_WORD = ['zero', 'one', 'two', 'three', 'four', 'five', 'six', 'seven', 'eight', 'nine', 'ten'][DRAFT_TEAM_COUNT];
export function dayIndex() {
  const now = new Date();
  const start = new Date(now.getFullYear(), 0, 0);
  return Math.floor((now - start) / 86400000);
}

export function pickDaily(variants) {
  if (!Array.isArray(variants) || variants.length === 0) return null;
  return variants[dayIndex() % variants.length];
}

export const FILM_OPEN_SUBS = [
  `${DRAFT_PICK_COUNT} players changed hands in the dining room. The record stayed behind.`,
  'The board closed. The Office of the Registrar did not.',
  'A beautiful new build. A less beautiful set of grades.',
  `${DRAFT_ROUND_COUNT} rounds went in. ${DRAFT_TEAM_COUNT} letters came out.`,
];

export const FILM_OPEN_TAGS = [
  'The draft is over. The record is not.',
  'The board closed. The file opened.',
  'Filed from the dining room.',
  'Measured, entered, available for appeal.',
];

export const FILM_END_CARDS = [
  { eyebrow: 'Final filing · Draft issue', a: 'The draft is over.', b: 'The season is the appeal.' },
  { eyebrow: 'Board closed · File open', a: 'The draft is over.', b: 'The season is the appeal.' },
  { eyebrow: 'The Registrar has adjourned', a: 'The draft is over.', b: 'The season is the appeal.' },
  { eyebrow: 'Grades filed · Arguments pending', a: 'The draft is over.', b: 'The season is the appeal.' },
];

export const MASTHEAD_VARIANTS = [
  {
    eyebrow: 'DRAFT ISSUE',
    lineA: 'THE GRADES ARE IN.',
    lineB: 'SEASON XIV LOADS.',
    dek: 'The board is closed, the composite scores are filed, and every manager has found a problem with the methodology.',
  },
  {
    eyebrow: 'VOL XIV · POST-DRAFT RECORD',
    lineA: `${DRAFT_TEAM_COUNT_WORD.toUpperCase()} DOSSIERS.`,
    lineB: 'ZERO ABSTENTIONS.',
    dek: `${DRAFT_INPUT_COUNT} inputs produced ${DRAFT_TEAM_COUNT_WORD} letters. The Bureau anticipates ${DRAFT_TEAM_COUNT_WORD} independently reasoned objections.`,
  },
  {
    eyebrow: 'OFFICE OF THE REGISTRAR',
    lineA: 'BOARD CLOSED.',
    lineB: 'APPEALS OPEN.',
    dek: `${DRAFT_PICK_COUNT} selections have been entered into the record. Complaints may now begin.`,
  },
  {
    eyebrow: '2026 SEASON FILE',
    lineA: 'THE MATH IS DONE.',
    lineB: 'THE GAMES ARE NEXT.',
    dek: 'The draft has a winner on paper. Thursday begins the less cooperative portion of the review.',
  },
];
